import styled from 'styled-components'

export const Title = styled.h2`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 20px;
  color: #303030;
`

export const Button = styled.button<{ variant?: 'primary' | 'outline' }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  border-radius: 20px;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  cursor: pointer;

  ${props => props.variant === 'primary' ? `
    background-color: #0090D3;
    color: #FFFFFF;
    border: none;
  ` : `
    background-color: #FFFFFF;
    color: #0090D3;
    border: 1px solid #0090D3;
  `}
`

export const Card = styled.div`
  background-color: #FFFFFF;
  border-radius: 16px;
  border-left: 1px solid #f4f4f4;
  padding: 20px;
  width: 100%;
  margin-bottom: 1rem;
`

export const FormGrid = styled.div`
  display: flex;
  gap: 32px;
  margin-bottom: 20px;

  &.mt {
    margin-top: 16px;
  }
`

export const FormGroup = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Label = styled.label`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  color: #303030;
`

export const ShortLabel = styled.label`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  color: #303030;
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
`

export const ShortLabelText = styled.span`
  font-weight: normal;
`

export const SeparatorImg = styled.img`
  flex-shrink: 0;
  margin: 0 0.5rem;
`

export const Select = styled.select`
  padding: 10px 16px;
  background-color: #EBEBEB;
  border: none;
  border-radius: 20px;
  color: #696969;
  font-family: 'Inter', sans-serif;
  outline: none;
`

export const InfoLink = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #0090D3;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
`

export const InfoPopoverWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`

export const Separator = styled.hr`
  border: none;
  height: 1px;
  background-color: #EBEBEB;
  margin: 20px 0;
`

export const CollapsibleHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`

export const Summary = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 32px;
`

export const SummaryItem = styled.div`
  flex: none;
  display: flex;
  gap: 8px;
`

export const SummaryLabel = styled.span`
  font-family: 'Inter', sans-serif;
  color: #696969;
  white-space: nowrap;
`

export const SummaryValue = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  color: #303030;
`

export const KitSummaryLabel = styled(SummaryLabel)`
  color: #000;
  font-weight: 600;
`

export const ActionButtonsRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  margin-top: 12px;
`

export const AddProductContainer = styled.div`
  margin-top: 16px;
`

export const AddButton = styled.div`
  width: 13.9vw;
  min-width: 220px;
  height: 5.9vh;
  min-height: 44px;
  border-radius: 20px;
  border: 1px solid #0090D3;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin: 20px auto;
`

export const AddButtonImg = styled.img`
  width: 0.8vw;
  min-width: 14px;
  height: 1.7vh;
  min-height: 14px;
  color: #0090D3;
`

export const AddButtonText = styled.p`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: #0090D3;
  white-space: nowrap;
`

export const BreadCrumble = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 1rem;
`

export const FirstText = styled.p`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 1rem;
  color: #0090D3;
`

export const SecondText = styled.p`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 1rem;
  color: #696969;
`

export const MoreInformation = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 23vw;
  height: 29vh;
  padding: 12px;
  border-radius: 0 16px 16px 16px;
  border: 1px solid #EBEBEB;
  background-color: #FFFFFF;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.08);
  z-index: 10;
`

export const InfoName = styled.p`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #696969;
  display: flex;
  gap: 16px;
  height: 21px;
`

export const InfoValue = styled.p`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #303030;
`

export const Input = styled.input`
  padding: 10px 16px;
  background-color: #EBEBEB;
  border: none;
  border-radius: 20px;
  color: #696969;
  font-family: 'Inter', sans-serif;
  outline: none;
`

export const InputText = styled.input`
  padding: 10px 16px;
  background-color: #EBEBEB;
  border: none;
  border-radius: 20px;
  color: #696969;
  font-family: 'Inter', sans-serif;
  outline: none;
`

export const FileUploadContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;
`

export const FileUploadLabel = styled.label`
  padding: 10px 24px;
  background-color: #0090D3;
  color: #FFFFFF;
  border-radius: 20px;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
`

export const FileNameText = styled.span`
  font-family: 'Inter', sans-serif;
  color: #696969;
  font-size: 14px;
`

export const OptionAddRow = styled.div`
  display: flex;
  gap: 8px;
`

export const OptionSelectRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`

export const ProductFieldsRow = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  min-width: 0;
  gap: 0;
  overflow-x: auto;
`

export const KitSummaryRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  & > :first-child {
    flex: 1;
  }
`

export const KitTrashImg = styled.img`
  cursor: pointer;
  margin-left: 24px;
  flex-shrink: 0;
`

export const ActionIconImg = styled.img`
  cursor: pointer;
`